// extracted by mini-css-extract-plugin
export default {"container":"Carousal_container__pGZIS","image_container":"Carousal_image_container__KLLHO"};